/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DemandeInscriptionFichierGridDto
 */
export interface DemandeInscriptionFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionFichierGridDto
     */
    iddemandeInscriptionFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeInscriptionFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DemandeInscriptionFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DemandeInscriptionFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the DemandeInscriptionFichierGridDto interface.
 */
export function instanceOfDemandeInscriptionFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DemandeInscriptionFichierGridDtoFromJSON(json: any): DemandeInscriptionFichierGridDto {
    return DemandeInscriptionFichierGridDtoFromJSONTyped(json, false);
}

export function DemandeInscriptionFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeInscriptionFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddemandeInscriptionFichier': !exists(json, 'iddemandeInscriptionFichier') ? undefined : json['iddemandeInscriptionFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function DemandeInscriptionFichierGridDtoToJSON(value?: DemandeInscriptionFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddemandeInscriptionFichier': value.iddemandeInscriptionFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

